var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { alertErrorHandler, showSuccess } from '@spike/notifications-action';
import Axios from 'axios';
import isEmpty from 'lodash/isEmpty';
import { VETS_ERROR_ACTION_TYPE, VETS_FETCH_START_ACTION_TYPE, VETS_FETCH_SUCCESS_ACTION_TYPE, VETS_GET_START_ACTION_TYPE, VETS_GET_SUCCESS_ACTION_TYPE, VETS_RESET_ACTION_TYPE, VETS_SAVE_START_ACTION_TYPE, VETS_SAVE_SUCCESS_ACTION_TYPE, } from './VetsActionsTypes';
import { convertToBody, convertToVet } from './VetsConverter';
var vetsUrl = '/vets';
var vetSearchUrl = '/vet/search';
export var fetchVetsThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(vetsUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchSuccess(response.data));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!Axios.isCancel(apiError_1)) {
                        dispatch(error());
                        alertErrorHandler(apiError_1, dispatch, 'Error fetching vets.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getVetThunk = function (apiClientWrapper, vetId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(vetsUrl, "/").concat(vetId, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getSuccess(response.data));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    if (!Axios.isCancel(apiError_2)) {
                        dispatch(error());
                        alertErrorHandler(apiError_2, dispatch, 'Error getting vet.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var saveVetThunk = function (apiClientWrapper, vet) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var unsavedVet_1, marketplaceId, searchUrl, actualVet, apiClientMethod, saveUrl, body, response, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(saveStart());
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, , 6]);
                    unsavedVet_1 = __assign({}, vet);
                    marketplaceId = apiClientWrapper.marketplaceId;
                    if (!(!unsavedVet_1.id && !isEmpty(vet.email))) return [3 /*break*/, 3];
                    searchUrl = "".concat(vetSearchUrl, "?query=").concat(encodeURI(unsavedVet_1.email), "&marketplace_id=").concat(marketplaceId);
                    return [4 /*yield*/, apiClientWrapper.apiClient
                            .get(searchUrl, apiClientWrapper.requestConfig)
                            .then(function (response) {
                            return response.data.some(function (dto) { return dto.email === unsavedVet_1.email; })
                                ? convertToVet(response.data.find(function (dto) { return dto.email === unsavedVet_1.email; }))
                                : undefined;
                        })
                            .catch(function (error) {
                            throw error;
                        })];
                case 2:
                    actualVet = _a.sent();
                    unsavedVet_1.id = actualVet === null || actualVet === void 0 ? void 0 : actualVet.id;
                    _a.label = 3;
                case 3:
                    apiClientMethod = vet.id ? apiClientWrapper.apiClient.patch : apiClientWrapper.apiClient.post;
                    saveUrl = vet.id
                        ? "".concat(vetsUrl, "/").concat(vet.id, "?marketplace_id=").concat(marketplaceId)
                        : "".concat(vetsUrl, "?marketplace_id=").concat(marketplaceId);
                    body = convertToBody(unsavedVet_1);
                    return [4 /*yield*/, apiClientMethod(saveUrl, body, apiClientWrapper.requestConfig)];
                case 4:
                    response = _a.sent();
                    dispatch(saveSuccess(response.data));
                    dispatch(showSuccess('Vet saved.'));
                    return [3 /*break*/, 6];
                case 5:
                    apiError_3 = _a.sent();
                    if (!Axios.isCancel(apiError_3)) {
                        dispatch(error());
                        alertErrorHandler(apiError_3, dispatch, 'Error saving vet.');
                    }
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
export var reset = function () {
    return {
        type: VETS_RESET_ACTION_TYPE,
    };
};
var fetchStart = function () {
    return {
        type: VETS_FETCH_START_ACTION_TYPE,
    };
};
export var fetchSuccess = function (vetDtos) {
    return {
        type: VETS_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            vets: vetDtos.map(function (vetDto) { return convertToVet(vetDto); }),
        },
    };
};
var getStart = function () {
    return {
        type: VETS_GET_START_ACTION_TYPE,
    };
};
export var getSuccess = function (vetDto) {
    return {
        type: VETS_GET_SUCCESS_ACTION_TYPE,
        payload: {
            vet: convertToVet(vetDto),
        },
    };
};
var saveStart = function () {
    return {
        type: VETS_SAVE_START_ACTION_TYPE,
    };
};
export var saveSuccess = function (vetDto) {
    return {
        type: VETS_SAVE_SUCCESS_ACTION_TYPE,
        payload: {
            vet: convertToVet(vetDto),
        },
    };
};
var error = function () {
    return {
        type: VETS_ERROR_ACTION_TYPE,
    };
};
